import React from 'react';
import { feeNoticeText, feeLineLabel } from '../lib/requestFee';

// The request fee, stated before the trader submits (owner's wording,
// 2026-09-29). A separate line in SAR — never part of a supplier's price.
// Renders nothing when the fee is switched off or its amount is unknown, so a
// form never promises a fee the server will not charge.
export default function RequestFeeNotice({ lang = 'ar', config, style }) {
  if (!config?.enabled || !(Number(config.amount) > 0)) return null;
  const isAr = lang === 'ar';
  const font = isAr ? 'var(--font-ar)' : 'var(--font-sans)';
  const amount = Number(config.amount);
  return (
    <div
      dir={isAr ? 'rtl' : 'ltr'}
      style={{
        padding: '12px 14px', borderRadius: 'var(--radius-md, 10px)',
        background: 'var(--bg-raised)', border: '1px solid var(--border-subtle)',
        display: 'flex', flexDirection: 'column', gap: 6, ...style,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontFamily: font, fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>
        <span>{feeLineLabel(lang)}</span>
        <span style={{ direction: 'ltr', fontVariantNumeric: 'tabular-nums' }}>{isAr ? `${amount} ر.س` : `SAR ${amount}`}</span>
      </div>
      <p style={{ margin: 0, fontFamily: font, fontSize: 12, lineHeight: 1.8, color: 'var(--text-secondary)' }}>
        {feeNoticeText(lang, amount)}
      </p>
    </div>
  );
}
